export default {
  BOX_OPACITY: 0.2, // opacité des boxes en labellisation boxing
  drawerWidth: 250,
  paths: {
    IMAGES_PATH: "/api/images",
    AUTH_PATH: "/api/authenticate",
    BATCHES_PATH: "/api/batches",
    PROJECT_BATCHES_PATH: "/api/batches/project",
    TAG_LIST: "/api/tagLists",
    TAG_LIST_UPDATE: "/api/tagLists/update",
    BATCHES_EXPORT_PATH: "/api/batches/export",
    BATCHES_AFFECTATION_PATH: "/api/batches/toUser",
    BATCHES_DEADLINE_PATH: "/api/batches/updateDeadline",
    BATCH_PREFIX_EXISTS: "/api/batches/isNameTaken",
    PROJECTS_PATH: "/api/projects",
    USER_PROJECTS_PATH: "/api/projects/user",
    PREVIEW_IMAGES_PATH: "/api/projects/preview-images",
    USER_REPORT_PATH: "/api/user/report",
    PROJECT_USERS_PATH: "/api/users/project",
    BATCH_GENERATION_PROGRESS_PATH:
      "/api/files/operations/inProgressOrFinishedLessThan5hAgo ",
    USER_BATCHES_PATH: "/api/batches/user",
    USERS_PATH: "/api/users",
    USER_USERS_PATH: "/api/users/user",
    REGISTER_USER: "/api/register",
    INIT_RESET_PASSWORD: "/api/account/reset-password/init",
    FINISH_RESET_PASSWORD: "/api/account/reset-password/finish",
    CHANGE_PASSWORD: "/api/account/change-password",
    GENERATE_BATCHES: "/api/batches/create",
    IMPORT_ES: "/api/files/esDownload",
    UPLOAD_PROPERTIES: "/app/uploadProperties",
    LIST_ES_INDICES: "/api/files/listEsIndices",
    LIST_ES_METATDATA: "/api/files/listEsMetadata",
    UPLOAD_FILES: "/api/files/uploadFiles",
    COUNT_ES: "/api/files/esCount",
    LIST_STAGGING_PATH: "/api/files/listStagingFolders",
    LIST_CLIENT_PATH: "/api/clients",
    PATH_PREDICT: "/api/images/predict",
    MODELS_PATH: "/api/models",
    PREDICTION_MODELS_PATH: "/api/prediction-models",
    MODEL_PREDICTIONS_PATH: "/api/images/model-predictions",
    BATCHES_APPLY_LABELING_PATH: "/api/batches/apply-labeling",
    QRCODE_PATH: "/api/authenticate/qr-code",
    VERIFY_CODE_PATH: "/api/authenticate/verify-code",
    LIST_S3_BUCKETS: "/api/files/listBuckets",
    APP_CONFIG: "/app/config",
    VIDEOS_INCOMING: "/api/videos/incoming",
    VIDEOS_DISPATCH: "/api/videos/dispatch",
  },
  motifsSkip: ["Rien à sélectionner", "Image floue"],
  colors: [
    { color: "#00A1FF", textColor: "white" },
    { color: "#7AD088", textColor: "white" },
    { color: "#F34955", textColor: "white" },
    { color: "#FFBD00", textColor: "white" },
    { color: "#7C73E3", textColor: "white" },
    { color: "#FF9966", textColor: "white" },
    { color: "#00C2A8", textColor: "white" },
    { color: "#FF00A8", textColor: "white" },
    { color: "#0036FF", textColor: "white" },
    { color: "#00E2E2", textColor: "white" },
    { color: "#D32F2F", textColor: "white" },
    { color: "#F9A825", textColor: "white" },
    { color: "#76FF03", textColor: "black" },
    { color: "#AA00FF", textColor: "white" },
    { color: "#C51162", textColor: "white" },
    { color: "#827717", textColor: "white" },
    { color: "#006064", textColor: "white" },
    { color: "#FF6B35", textColor: "white" },
    { color: "#43A047", textColor: "white" },
    { color: "#0277BD", textColor: "white" },
    { color: "#FF5722", textColor: "white" },
    { color: "#795548", textColor: "white" },
    { color: "#4CAF50", textColor: "white" },
    { color: "#9C27B0", textColor: "white" },
    { color: "#607D8B", textColor: "white" },
    { color: "#880E4F", textColor: "white" },
    { color: "#CDDC39", textColor: "black" },
    { color: "#1A237E", textColor: "white" },
    { color: "#558B2F", textColor: "white" },
    { color: "#FF8F00", textColor: "white" },
  ],
};
